<!-- eslint-disable vue/v-on-event-hyphenation -->
<template>
  <div :class="['nt-theme', getTheme]">
    <label>{{ label }}</label>
    <div
      :id="id"
      class="nt-checkgroup"
    >
      <nt-check
        v-for="(item, i) in dataSource"
        :id="id + '-check-' + i"
        :key="item.id"
        :theme="theme"
        :item="item"
      />
    </div>
    <div
      v-if="error"
      class="nt-form-error"
    >
      {{ error }}
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import _ from 'lodash'
import emitter from 'tiny-emitter/instance'
import NtCheck from './form-check.vue'

export default {
  name: 'nt-checkgroup',
  components: {
    NtCheck
  },
  props: {
    id: {
      type: String,
      default: 'checkgroup'
    },
    label: {
      type: String,
      default: null
    },
    dataSource: {
      type: Array,
      default: []
    },
    validators: {
      type: Array,
      default: []
    },
    theme: {
      type: String,
      default: 'default'
    },
  },
  data() {
    return {
      selected: [],
      error: null
    }
  },
  computed: {
    ...mapGetters('formStore', ['formData']),
    ...mapState('formStore', ['errors']),
    getTheme() {
      return `nt-theme--${this.theme}`
    }
  },
  watch: {
    errors: {
      handler(values) {
        const { id } = this
        const error = values.find((value) => value[id]) || {}
        this.error = error[id]
      },
      deep: true
    }
  },
  created() {
    // Add to form initial values
    this.changeForm()
    // Add validators to form
    this.changeValidators({
      [this.id]: this.validators
    })

    emitter.on('onSelectFormCheck', this.onSelect)
  },
  methods: {
    ...mapActions('formStore', ['changeFormData', 'changeValidators']),
    onSelect(item) {
      if (item.Checked) {
        this.addItem(item)
      } else {
        this.removeItem(item)
      }
      this.changeForm()
    },
    addItem(item) {
      this.selected.push(item.Value)
    },
    removeItem(item) {
      _.pull(this.selected, item.Value)
    },
    changeForm() {
      emitter.emit('changeForm', {
        [this.id]: this.selected.length ? this.selected : null
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .nt-theme {
    & .nt-checkgroup {
      display: flex;
      flex-wrap: wrap;

      & .radio {
        margin-bottom: 0.3125rem;
        &:not(:last-child) {
          margin-right: 20px;
        }
      }

      & .check {
        margin-bottom: 0.3125rem;
        &:not(:last-child) {
          margin-right: 1.25rem;
        }
      }
    }
  }
</style>
